import Vue from "vue";
import VueI18n from "vue-i18n";
import { getCookie } from "@/apis/cookie";
import { merge } from "lodash";
import zh_CN from "./zh_CN.js";
import en_US from "./en_US.js";
import axios from "axios";
import defLan from "./default";
Vue.use(VueI18n);
const lang = getCookie("lan") || "zh_CN";

const messages = {
  def_Lan: {
    ...defLan,
  },
};
export const i18n = new VueI18n({
  locale: "def_Lan",
  messages,
  missing() {
    return "";
  },
});
// export const i18n = new VueI18n({
//   locale: lang,
//   messages: {
//     zh_CN: zh_CN,
//     en_US: en_US,
//     el_GR: el_GR,
//   },
// });

let privareData = "";
switch (lang) {
  case "zh_CN":
    privareData = zh_CN;
    break;
  case "en_US":
    privareData = en_US;
    break;
  case "el_GR":
    privareData = zh_CN;
    break;
  case "nl_NL":
    privareData = en_US;
    break;
  case "ja_JP":
    privareData = en_US;
    break;
  case "ko_KR":
    privareData = en_US;
    break;
  case "ar_AE":
    privareData = en_US;
    break;
  case "ru_RU":
    privareData = en_US;
    break;
  case "fr_FR":
    privareData = en_US;
    break;
  case "es_ES":
    privareData = en_US;
    break;
  case "pt_BR":
    privareData = en_US;
    break;
  case "tr_TR":
    privareData = en_US;
    break;
  case "mn_MN":
    privareData = en_US;
    break;
  case "vi_VN":
    privareData = en_US;
    break;
  case "th_TH":
    privareData = en_US;
    break;
  case "kn_IN":
    privareData = en_US;
    break;
  case "id_ID":
    privareData = en_US;
    break;
  case "it_IT":
    privareData = en_US;
    break;
  case "pl_PL":
    privareData = en_US;
    break;
  case "uk_UA":
    privareData = en_US;
    break;
  case "zh_TC":
    privareData = zh_CN;
    break;
}
// 初始化走本地多语言
export function info(lan) {
  i18n.locale = lan;

  i18n.setLocaleMessage(lan, privareData);
}
info(lang);

export function changeLanguage(languageConfList) {
  const lan = getCookie("lan") || "zh_CN";
  let ossUrl = "";
  languageConfList.forEach((item) => {
    if (item.langKey === lan) {
      ossUrl = item.nowFileAddress;
    }
  });

  if (ossUrl) {
    console.log(ossUrl,'ossUrl')
    axios({
      method: "get",
      // url: 'https://dev-saas-oss.oss-cn-hongkong.aliyuncs.com/upload/20201209163255394.json',
      url: ossUrl,
      headers: {
        "content-type": "application/json",
      },
    }).then((res) => {
      i18n.locale = lan;
      let merchantLocaleData = res.data ? res.data : {};
      let mergeData = merge(privareData, merchantLocaleData);
      // let mergeData = merge(privareData);
      i18n.setLocaleMessage(lan, mergeData);
    });
  }
}
